<template>
<div class="lists-top">
			<div style="line-height: 38.83px;" class="el-page-header__content">{{title||(getTitle)}}</div>
			<div>
			<!-- 	<el-button  size="mini" class="b-primary text-primary"  @click="operateCommand('导入')" ><img width="16" height="16" src="../../assets/icon/导入/蓝色.png" style=" vertical-align: middle;
margin-right: 5px;">导入数据</el-button> -->
				<el-button  size="mini" style="border: 1px solid #2f54eb!important;" v-if="!getOperate&&getButton.indexOf('添加')!=-1" @click="operateCommand('添加')" type="primary"><img width="16" height="16" src="../../assets/icon/添加/白色.png" style=" vertical-align: middle;
margin-right: 5px;"> 添加信息</el-button>
<el-button  size="mini" style="border: 1px solid #2f54eb!important;" @click="returnClick()" v-if="getOperate" type="primary"><img width="16" height="16" src="../../assets/icon/返回/白色.png" style=" vertical-align: middle;
margin-right: 5px;"> 返回列表</el-button>
			</div>
		</div>
	  </template>
<script>
	  export default {
		      props: {
		      	title: {
		      		type: String,
		      		default: ''
		      	}
		      } ,
	    data() {
	      return {
			 }
	    },
		computed:{
			getTitle(){
				return this.$store.state.menu.name||"首页"
			},
			getButton(){
				return this.$store.state.menu.meta?(this.$store.state.menu.meta.button||''):""
			},
			getOperate(){
				return this.$store.state.operate=='添加'||this.$store.state.operate=='编辑'||this.$store.state.operate=='详情'||this.$store.state.operate=='复制'
			}
		}
		,mounted() {
		    },
	    methods: {
			returnClick(e){
				 this.$store.commit("saveOperate", '');
			},
			operateCommand(e){
				 this.$store.commit("saveOperate", e);
			 this.$emit("callbackOperate",{operate:e}); 
			},
		},
	  }
</script>

<style>
</style>
